<template>
  <section>
    <!-- search -->
    <form @submit.prevent="loadData" v-if="res">
      <div class="section_search">
        <div class="tray">
          <div class="row">
            <div class="cell">
              <dl class="target_info">
                <dt class="name">{{res.rcpName}}</dt>
                <dd class="personal blank">
                  <p class="part">
                    ({{res.rcpGender}}/{{res.rcpAge}}/{{res.orgFullName}})
                    <span class="member">NUGU Device No: {{res.deviceId}} <span class="dash">|</span> TID : {{res.tid}}</span>
                  </p>
                  <p v-if="res.firstUseDate" class="part">
                    최초 이용날짜 :
                    {{res.firstUseDate}}
                    <span class="dash">|</span> 최근 이용날짜 :
                    {{res.lastUseDate}}
                  </p>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- //search -->

    <h4 v-if="res" class="section_title">
      <span class="ico"></span>기억검사 결과
    </h4>

    <PagingTable
     :sourceList="tableItems"
     :itemPerPage="10"
     :useExcel="true"
     ref="table">
      <template #header>
        <caption><span class="blind">통계 목록</span></caption>
        <colgroup>
          <col width="6%">
          <col width="6%">
          <col width="12%">
          <col width="12%">
          <col width="7%">
          <col width="7%">
          <col width="7%">
          <col width="7%">
          <col width="7%">
          <col width="7%">
          <col width="7%">
          <col width="7%">
          <col width="8%">
        </colgroup>

        <thead class="table_list_head table_list_head_line">
        <tr>
          <th>Round</th>
          <th>회차</th>
          <th class="sorting" data-sort="name">수행일자</th>
          <th>기억건강 단계</th>
          <th>정답수</th>
          <th>1번</th>
          <th>2번</th>
          <th>3번</th>
          <th>4번</th>
          <th>5번</th>
          <th>6번</th>
          <th>7번</th>
          <th>8번</th>
        </tr>
        </thead>
      </template>
      <template #row={rowData}>
        <tr>
          <td>{{rowData.round}}</td>
          <td>{{rowData.order}}</td>
          <td>{{rowData.useDate}}</td>
          <td><span :class="highlight(rowData.status)">{{rowData.status}}</span></td>
          <td>{{rowData.correctCount}}</td>
          <td>{{rowData.number1}}</td>
          <td>{{rowData.number2}}</td>
          <td>{{rowData.number3}}</td>
          <td>{{rowData.number4}}</td>
          <td>{{rowData.number5}}</td>
          <td>{{rowData.number6}}</td>
          <td>{{rowData.number7}}</td>
          <td>{{rowData.number8}}</td>
        </tr>
      </template>
    </PagingTable>
    <div v-if="tableItems && tableItems.length" class="section_button none_paginate">
      <button type="button" class="btn_excel" @click="excelDownload"><span class="ico"></span>엑셀저장</button>
    </div>
  </section>
</template>

<script>
  import mixin from './_mixin'
  import XLSX from 'xlsx'

  export default {
    mixins: [ mixin ],
    data() {
      const id = this.$route.params.id
      return {
        id,
        res: null,
      }
    },
    computed: {
      tableItems() {
        if (!this.res) return null
        return this.res.dementiaResults
      }
    },
    methods: {
      highlight(val) {
        return val === '미완료' ? 'important' : ''
      },
      excelDownload() {
        const table = this.$refs.table.getExcelTable()
        const wb = XLSX.utils.table_to_book(table, {sheet: '기억검사 결과'})
        XLSX.writeFile(wb, `대상자상세통계(${this.res.rcpName}).xlsx`)
      },
      loadData() {
        this.$axios.get(`/admin/happy/stats/rcp/${this.id}/detail`).then(({data}) => this.res = data)
      }
    },
    mounted() {
      this.loadData()
    }
  }
</script>
